declare const ENUM_STRINGS: any

export default function enumValue(stringValue, intValue){

    return ENUM_STRINGS ? stringValue : intValue;
}